// components/CheckoutPixAppmax.js
"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { motion } from "framer-motion"
import { Copy, CheckCircle, AlertCircle, Clock } from "lucide-react"
import "../styles/checkout.css"

const CheckoutPixAppmax = ({
  pedidoId,
  total,
  nomeVaqueiro,
  eventoid,
  nomeEvento,
  valorTaxa,
  totalComTaxa,
  categoria // <- aqui agora está definido corretamente
}) => {
  const [qrCode, setQrCode] = useState(null)
  const [pixCopiaCola, setPixCopiaCola] = useState("")
  const [erro, setErro] = useState("")
  const [expiraEm, setExpiraEm] = useState(null)
  const [contador, setContador] = useState("")
  const [copiado, setCopiado] = useState(false)
  const [expirado, setExpirado] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const metodoAtual = "pix"
    const metodoSelecionado = sessionStorage.getItem("metodoSelecionado")
    if (metodoSelecionado !== metodoAtual) return

    const gerarPixAppmax = async () => {
      setLoading(true)
      try {
        const usuario = JSON.parse(localStorage.getItem("user"))
        if (!usuario || !usuario.cpf || !usuario.email) {
          setErro("Usuário não encontrado. Faça login novamente.")
          return
        }

        const response = await axios.post("https://api.ticketdovaqueiro.com/api/pagamento/appmax/pix", {
          cliente: {
            firstname: nomeVaqueiro || "Cliente",
            lastname: "Vaqueiro",
            email: usuario.email,
            telephone: usuario.whatsapp,
            postcode: "01010000",
            address_street: "Rua Teste",
            address_street_number: "123",
            address_street_district: "Centro",
            address_city: "São Paulo",
            address_state: "SP",
            ip: "127.0.0.1"
          },
          produtos: [{
            sku: "VAQ-" + pedidoId,
            nome: `Senha ${categoria}`,
            qtd: 1
          }],
          cpf: usuario.cpf,
          total: totalComTaxa,

        })

        const pixData = response.data

        setQrCode(pixData.qr_code_base64)
        setPixCopiaCola(pixData.url_copy_paste)



        const dataExp = new Date(pixData.expiracao)
        if (!isNaN(dataExp.getTime())) {
          setExpiraEm(dataExp)
        }
      } catch (err) {
        console.error("Erro ao gerar Pix Appmax:", err)
        setErro("Erro ao gerar Pix. Tente novamente.")
      } finally {
        setLoading(false)
      }
    }

    gerarPixAppmax()
  }, [pedidoId])

  useEffect(() => {
    if (!expiraEm) return
    const interval = setInterval(() => {
      const agora = new Date()
      const diferenca = expiraEm - agora
      if (diferenca <= 0) {
        setContador("Expirado")
        setExpirado(true)
        clearInterval(interval)
      } else {
        const minutos = Math.floor(diferenca / 60000)
        const segundos = Math.floor((diferenca % 60000) / 1000)
        setContador(`${minutos}:${segundos.toString().padStart(2, "0")}`)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [expiraEm])

  const copiarCodigo = () => {
    navigator.clipboard.writeText(pixCopiaCola)
    setCopiado(true)
    setTimeout(() => setCopiado(false), 2000)
  }

  if (loading) return <div className="pix-loading"><p>Gerando QR Code via Appmax...</p></div>
  if (erro) return <div className="pix-erro"><AlertCircle size={24} /><p>{erro}</p></div>

  return (
    <motion.div className="pix-container">
      <h3>Pagamento via Pix - Appmax</h3>
      <p>Escaneie o QR Code ou copie o código abaixo:</p>
      <img src={`data:image/png;base64,${qrCode}`} alt="QR Code Pix" className="qr-code-img" />
      <input value={pixCopiaCola} readOnly className="copia-cola-input" />
      <button onClick={copiarCodigo} className="btn-copiar">
        {copiado ? <CheckCircle size={18} /> : <Copy size={18} />}
        {copiado ? "Código copiado!" : "Copiar Código"}
      </button>
      <p className="expiracao-timer">
        <Clock size={16} className="timer-icon" />
        Expira em: {contador}
      </p>
      {expirado && (
        <motion.div className="pix-expirado">
          <AlertCircle size={18} /> O Pix expirou. Gere um novo.
        </motion.div>
      )}
    </motion.div>
  )
}

export default CheckoutPixAppmax
